'use client';

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchAboutHome } from '../api';
import aboutImage from '../../assets/images/abouts-us.png';
import { useTranslation } from 'react-i18next';

interface AboutData {
  _id: string;
  title: { en: string; ar: string };
  description: { en: string; ar: string };
  featurePoints: Array<{ en: string; ar: string }>;
  createdAt: string;
  updatedAt: string;
}

const AboutUs: React.FC = () => {
  const [aboutData, setAboutData] = useState<AboutData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { t, i18n } = useTranslation();

  // Fetch about data on component mount
  useEffect(() => {
    const loadAboutData = async () => {
      try {
        const data = await fetchAboutHome();
        setAboutData(data);
        setLoading(false);
      } catch (err) {
        setError(t('failed_to_load_about'));
        setLoading(false);
      }
    };
    loadAboutData();
  }, [t]);

  // Determine the current language (en or ar)
  const currentLang = i18n.language === 'ar' ? 'ar' : 'en';

  if (!aboutData) {
    return (
      <div className="container text-center my-5">
        <div className="main-title">{/* <h2>{t('no_about_data')}</h2> */}</div>
      </div>
    );
  }

  return (
    <>
      <section
        className="about-us z-0 top-100"
        dir={currentLang === 'ar' ? 'rtl' : 'ltr'}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="main-title">
                <h2>{t('about_us')}</h2>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-md-6">
              <div className="content_wrapper">
                <h2>{aboutData.title[currentLang]}</h2>
                <p>{aboutData.description[currentLang]}</p>

                {aboutData.featurePoints.map((point, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <span
                      style={{
                        width: '14px',
                        height: '14px',
                        border: '3px solid #0a2c50',
                        borderRadius: '50%',
                        display: 'inline-block',
                        marginRight: currentLang === 'ar' ? '0' : '10px',
                        marginLeft: currentLang === 'ar' ? '10px' : '0',
                      }}
                    ></span>
                    <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                      {point[currentLang]}
                    </span>
                  </div>
                ))}
              </div>

              <div
                className="button_text text-start"
                style={{ marginTop: '40px' }}
              >
                <Link to="/about-us">{t('view_more')}</Link>
              </div>
            </div>

            <div className="col-md-6 mt-5 mt-md-0">
              <img src={aboutImage} alt={t('about_us')} className="img-fluid" />
            </div>
          </div>
        </div>

        <style>{`
        .about-us {
          padding: 50px 0;
          }
          .main-title h2 {
            font-size: 2.5rem;
            font-weight: bold;
            color: #0a2c50;
            margin-bottom: 20px;
            }
            .content_wrapper h2 {
              font-size: 1.8rem;
              font-weight: bold;
              color: #0a2c50;
              margin-bottom: 20px;
              }
              .content_wrapper p {
                font-size: 1rem;
                color: #333;
                line-height: 1.6;
                margin-bottom: 20px;
                }
                .button_text a {
                  font-weight: bold;
                  text-decoration: none;
                  transition: color 0.3s ease;
                  }
                  .button_text a:hover {
                    color: #3558b2;
                    }
                    @media (max-width: 767px) {
                      .content_wrapper h2 {
                        font-size: 1.5rem;
                        }
                        .main-title h2 {
                          font-size: 2rem;
                          }
                          }
                          `}</style>
      </section>
    </>
  );
};

export default AboutUs;
